import EventEmitter from 'eventemitter3';

export enum REQUEST_ERROR_EVENTS {
    TOGGLE_REQUEST_ERROR_MODAL = 'TOGGLE_REQUEST_ERROR_MODAL',
}
export type ToggleRequestErrorPayload = {
    showModal: boolean;
    errorMessage?: string;
    title?: string;
};
const RequestErrorEventEmitter = new EventEmitter();
export default RequestErrorEventEmitter;
